const namespace = 'userlist/'

export const SET_CONDITIONS = namespace + '.SET_CONDITIONS'
